var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadarColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.998 9.77a1.771 1.771 0 1 0 0-3.541 1.771 1.771 0 0 0 0 3.542z",
    fill: "#1080FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.953 13.023a.558.558 0 0 1-.446-.893A6.823 6.823 0 0 0 14.882 8a6.823 6.823 0 0 0-1.377-4.13.558.558 0 0 1 .893-.67A7.906 7.906 0 0 1 16 8c0 1.749-.55 3.408-1.6 4.8a.55.55 0 0 1-.446.223zM2.046 13.023A.55.55 0 0 1 1.6 12.8 7.906 7.906 0 0 1 0 8c0-1.749.55-3.408 1.6-4.8a.558.558 0 0 1 .893.67A6.823 6.823 0 0 0 1.116 8c0 1.503.476 2.932 1.377 4.13a.558.558 0 0 1-.447.893z",
    fill: "#1080FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.57 11.237a.558.558 0 0 1-.447-.893A3.845 3.845 0 0 0 11.905 8c0-.856-.268-1.667-.781-2.344a.558.558 0 0 1 .893-.67A5.008 5.008 0 0 1 13.02 8c0 1.094-.35 2.143-1.005 3.014a.55.55 0 0 1-.446.223zM4.428 11.237a.55.55 0 0 1-.447-.223A5.008 5.008 0 0 1 2.977 8c0-1.094.35-2.143 1.004-3.014a.558.558 0 0 1 .893.67A3.845 3.845 0 0 0 4.093 8c0 .856.268 1.667.781 2.344a.558.558 0 0 1-.446.893z",
    fill: "#1080FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadarColor);
export default __webpack_public_path__ + "static/media/radar_color.517dfff2045a03408b9aa68fed27915d.svg";
export { ForwardRef as ReactComponent };